import { Component, OnInit } from '@angular/core';
import { NotificationService } from './notification.service';
import { Notification } from './notification';
import { NotificationType } from './notification-type.enum';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  constructor(
    private service: NotificationService
  ) { }

  ngOnInit() {
  }

  Close(notif: Notification) {
    this.service.Close(notif);
  }

  GetType(notif: Notification) {
    switch (notif.Type) {
      case NotificationType.Dark:
        return "alert-dark";
      case NotificationType.Primary:
        return "alert-primary";
      case NotificationType.Secondary:
        return "alert-secondary";
      case NotificationType.Success:
        return "alert-success";
      case NotificationType.Danger:
        return "alert-danger";
      case NotificationType.Warning:
        return "alert-warning";
      case NotificationType.Info:
        return "alert-info";
      default:
        return "alert-light";
    }
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/notification/notification.component.ts